import { FC } from "react";
import { GridApi } from "ag-grid-community";
import moment from "moment";
import { Stack } from "@mui/material";
import { useFlag } from "@unleash/proxy-client-react";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { OpportunitiesCount } from "@/components/pages/common/opportunities/components/toolbar/OpportunitiesCount";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";
import { AgGridGlobalSearch } from "@/components/pages/common/ag-grid/components/global-search/AgGridGlobalSearch";
import { AGGridExportCSV } from "@/components/pages/common/ag-grid/components/AGGridExportCSV";
import { AGGridColumnsToolPanel } from "@/components/pages/common/ag-grid/components/AGGridColumnsToolPanel";
import { useAppSelector } from "@/store/hooks";
import { aiKubernetesRecommendationsSelectedItemsSelector } from "@/store/ai-kubernetes-recommendations/selectors/aiKubernetesRecommendationsSelectedItemsSelector";
import { OpportunitiesCreateTaskToolbarAction } from "@/components/pages/common/opportunities/components/toolbar/OpportunitiesCreateTaskToolbarAction";

interface AiKubernetesRecommendationsTableToolbarProps {
  gridApi: GridApi | null;
}

export const AiKubernetesRecommendationsTableToolbar: FC<
  AiKubernetesRecommendationsTableToolbarProps
> = ({ gridApi }) => {
  const fileName = `${formatDate(moment(), { type: "dashSeparated" })}-kubernetes-ai-recommendations.csv`;
  const enableTaskCreationFromAiKubernetesRecommendations = useFlag(
    "EnableTaskCreationFromAiKubernetesRecommendations",
  );

  const opportunities = useAppSelector(
    aiKubernetesRecommendationsSelectedItemsSelector,
  );

  return (
    <Stack
      pr={2}
      pl={1}
      py={1}
      top={0}
      spacing={2}
      bgcolor="white"
      zIndex="appBar"
      position="sticky"
      direction="row"
      justifyContent="space-between"
      borderBottom={1}
      borderColor="grey.300"
    >
      <Stack direction="row" spacing={1} height={32} alignItems="center">
        <OpportunitiesCount gridApi={gridApi} />

        <AgGridAllFiltersChip gridApi={gridApi} />
      </Stack>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={2}
      >
        {enableTaskCreationFromAiKubernetesRecommendations && (
          <Stack
            direction="row"
            borderRadius={2}
            bgcolor="grey.100"
            spacing={0.5}
          >
            <OpportunitiesCreateTaskToolbarAction
              opportunities={opportunities}
            />
          </Stack>
        )}

        <AgGridGlobalSearch gridApi={gridApi} />

        <AGGridExportCSV gridApi={gridApi} fileName={fileName} />

        <AGGridColumnsToolPanel gridApi={gridApi} />
      </Stack>
    </Stack>
  );
};
